import { Component, OnInit } from '@angular/core';
import { HttpService } from '../http.service';
@Component({
  selector: 'app-swinkpay-failed',
  templateUrl: './swinkpay-failed.component.html',
  styleUrls: ['./swinkpay-failed.component.scss'],
})
export class SwinkpayFailedComponent implements OnInit {
  message: any;
  chegUrl: any;
  deviceType: string = '';
  constructor(private httpService: HttpService) {
    this.message = this.httpService.getLocalStorage('Message');
    this.deviceType = this.httpService.getLocalStorage('DeviceType');
    this.chegUrl = this.httpService.getLocalStorage('ChegUrl');
    if (this.deviceType == 'web') {
      setTimeout(() => {
        window.open(this.chegUrl, '_self');
      }, 5000);
    }
    localStorage.clear();
    console.log('message', this.message);
    console.log('message', this.httpService.getLocalStorage('Message'));
  }

  ngOnInit(): void {}
}
